import { retryFetch } from './RetryHelper';
import { debug } from 'src/logger';
import initialMetricsPublisher from "src/metrics";

export interface GetSafeguardContractStatusRequest {
    contractTransactionId: String
}

export interface GetSafeguardContractStatusResponse {
    signed: boolean
}

export const getSafeguardContractStatus =
    async (params: GetSafeguardContractStatusRequest): Promise<GetSafeguardContractStatusResponse> => {
        try {
            return await retryFetch(async () => {
                debug('Making GetSafeguardContractStatus Request:', params);
                const response = await fetch('/getstarted/api/getSafeguardContractStatus', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                });
                if (!response.ok) {
                    if (response.status === 429) {
                        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('GetSafeguardContractStatusCall');
                        actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                    }
                    throw new Error('Encountered exception when calling GetSafeguardContractStatus')
                }

                const data = await response.json();
                debug('Received GetSafeguardContractStatus Response:', data);

                const allSigned = data.documents.every((doc: { documentStatus: string; }) => doc.documentStatus === 'signed');

                return {
                    signed: allSigned
                };
            });
        } catch (error) {
            console.error('Encountered exception calling GetSafeguardContractStatus');
            return { signed: false };
        }
}
